/* Native details remain usable without JavaScript; enhance dismissal and focus. */
(() => {
  if (window.martenbrownShellInitialized) return;
  window.martenbrownShellInitialized = true;
  const openMenus = () => document.querySelectorAll('.mb-reference-header .mb-nav-dropdown[open]');
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches('.mb-nav-dropdown') || !menu.open) return;
    const navigation = menu.closest('nav');
    openMenus().forEach((other) => {
      if (other !== menu && other.closest('nav') === navigation) other.open = false;
    });
  }, true);
  document.addEventListener('click', (event) => {
    openMenus().forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menus = [...openMenus()];
    if (!menus.length) return;
    const focused = menus.find((menu) => menu.contains(document.activeElement));
    menus.forEach((menu) => { menu.open = false; });
    if (focused) focused.querySelector('summary').focus();
  });
})();
